export default "__VITE_ASSET__d9a2c0db__"